export default [
  {
    // 公告列表页
    path: '/sys',
    name: 'sys',
    meta: {
      group: 'home',
    },
    component: () => import(/* webpackChunkName: "Sys" */ '../views/sys')
  },
  {
    // 公告详情页
    path: '/sys/:sys_id',
    name: 'sysDetail',
    meta: {
      group: 'home',
    },
    component: () => import(/* webpackChunkName: "SysDetail" */ '../views/sys/detail')
  },
  {
    // 预览
    path: '/sys/:sys_id/preview',
    name: 'preview',
    meta: {
      group: 'home',
    },
    component: () => import(/* webpackChunkName: "SysDetail" */ '../views/sys/preview')
  }
]
